<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  progress: { type: Object, default: () => ({ percent: 0 }) },
  blocks: { type: Object, default: () => ({}) },
});

const { t } = useI18n();

const items = computed(() => [
  {
    key: 'imovel',
    label: t('SALES.PROGRESS.PROPERTY'),
    value: Number(props.blocks?.imovel || 0),
  },
  {
    key: 'vendedores',
    label: t('SALES.PROGRESS.SELLERS'),
    value: Number(props.blocks?.vendedores || 0),
  },
  {
    key: 'compradores',
    label: t('SALES.PROGRESS.BUYERS'),
    value: Number(props.blocks?.compradores || 0),
  },
  {
    key: 'recibo',
    label: t('SALES.PROGRESS.RECEIPT'),
    value: Number(props.blocks?.recibo || 0),
  },
  {
    key: 'comissao',
    label: t('SALES.PROGRESS.COMMISSION'),
    value: Number(props.blocks?.comissao || 0),
  },
]);

const percent = computed(() =>
  Math.min(100, Math.max(0, Number(props.progress?.percent || 0)))
);
</script>

<template>
  <div class="min-w-[220px]">
    <div
      class="flex items-center justify-between gap-2 text-xs font-semibold text-lais-text-muted"
    >
      <span>{{ t('SALES.ARIA.PROGRESS') }}</span>
      <span>{{ t('SALES.COMMON.PERCENT', { value: percent }) }}</span>
    </div>
    <progress
      class="mt-2 h-2 w-full overflow-hidden rounded-full accent-lais-primary"
      :value="percent"
      max="100"
      :aria-label="t('SALES.ARIA.PROGRESS')"
    />
    <div class="mt-2 grid grid-cols-5 gap-1">
      <div v-for="item in items" :key="item.key" class="text-center">
        <span
          class="mx-auto grid size-6 place-items-center rounded-full text-[10px] font-bold"
          :class="
            item.value === 100
              ? 'bg-lais-primary text-white'
              : 'bg-lais-primary-50 text-lais-primary'
          "
        >
          {{ item.value }}
        </span>
        <span
          class="mt-1 block truncate text-[10px] text-lais-text-muted"
          :title="item.label"
          >{{ item.label }}</span
        >
      </div>
    </div>
  </div>
</template>
